import type { ReactNode } from 'react';

import {
    SheetDescription,
    SheetHeader,
    SheetPanel,
    SheetTitle,
} from '@/shared/ui/panels/sheet-panel';

export function TodaySessionsSheet({ children }: Readonly<{ children: ReactNode }>) {
    return (
        <SheetPanel type="sessions/today" side="bottom">
            <SheetHeader className="px-2">
                <SheetTitle>Today&apos;s Sessions</SheetTitle>
                <SheetDescription className="sr-only">
                    A list of today&apos;s client sessions.
                </SheetDescription>
            </SheetHeader>

            <div className="h-[50svh] min-h-0 flex flex-col">{children}</div>
        </SheetPanel>
    );
}
